require('./dist/details/ds6/details.css');
